var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFilterCollapse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.03236 11.3409C9.28422 11.615 9.42249 11.973 9.42249 12.3434V23.2571C9.42249 23.9139 10.2151 24.2473 10.6842 23.7855L13.7287 20.2966C14.1361 19.8077 14.3608 19.5657 14.3608 19.0817V12.3458C14.3608 11.9755 14.5016 11.6174 14.7509 11.3433L23.4868 1.86422C24.1412 1.1531 23.6375 0 22.6695 0H1.11373C0.145815 0 -0.360363 1.15063 0.296434 1.86422L9.03236 11.3409Z",
    fill: "#4C4C4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilterCollapse);
export default __webpack_public_path__ + "static/media/icon_filter_collapse.e3594aacf8323b2ea980e0996aa458f7.svg";
export { ForwardRef as ReactComponent };